<div class="activity-bg-section">
    <div class="activity-section">
        <div class="activity-heading-section">
            <span>Activity Details</span>
            <div>
                <ng-container *ngIf="!isReadOnly">
                    <ng-container *ngIf="activity_data.id != null">
                        <div class="each-activity-header-action-section">
                            <!-- <img src="assets/delete-activity.png" class="activity-header-action-icon" [matTooltip]="'Delete Activity'" (click)="removeActivity(activity_data)" /> -->

                            <!-- Remove Delete <img src="assets/activity-delete.png" class="activity-header-action-icon" [matTooltip]="'Delete Activity'" (click)="removeActivity(activity_data)" /> -->
                        </div>
                        <ng-container *ngIf="activity_data.status != 3">
                            <div class="each-activity-header-action-section" *ngIf="!activity_data.activity_paused">
                                <!-- <img src="assets/stop-activity.png" class="activity-header-action-icon" [matTooltip]="'Stop Activity'" (click)="openAutomatedActivityOperationModal()" /> -->
                                <img src="assets/activity-stop.png" class="activity-header-action-icon" [matTooltip]="'Stop Activity'" (click)="openAutomatedActivityOperationModal()" />
                            </div>
                            <div class="each-activity-header-action-section" *ngIf="activity_data.activity_paused">
                                <!-- <img src="assets/resume-activity.png" class="activity-header-action-icon" [matTooltip]="'Resume Activity'" (click)="openAutomatedActivityOperationModal()" /> -->
                                <!-- <img src="assets/record-history.png" class="activity-header-action-icon" [matTooltip]="'Resume Activity'" (click)="openAutomatedActivityOperationModal()" /> -->
                                <img src="assets/activity-reume.png" class="activity-header-action-icon" [matTooltip]="'Resume Activity'" (click)="openAutomatedActivityOperationModal()" />
                            </div>
                        </ng-container>
                        <!-- <div class="each-activity-header-action-section" *ngIf="activity_data.communication_type_name == 'Email'">
                            <img src="assets/send-email.png" class="activity-header-action-icon" [matTooltip]="'Send Email'" (click)="openEmail(data)" />
                            <img src="assets/email-active.png" class="activity-header-action-icon" [matTooltip]="'Send Email'" (click)="openEmail(activity_data)" />
                            <img src="assets/activity-send-email.png" class="activity-header-action-icon" [matTooltip]="'Send Email'" (click)="openEmail(activity_data)" />
                        </div> -->
                    </ng-container>
                    <!-- <div class="each-activity-header-action-section" *ngIf="((activity_data.activity_type == 1) || (activity_data.activity_type == 4) || (activity_data.activity_type == 5))"> -->
                    <!-- <div class="each-activity-header-action-section" *ngIf="activity_data.email_template != null && user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team' && user_role != 'Wholesaler'"> -->
                    <div class="each-activity-header-action-section" *ngIf="activity_data.email_template != null && user_role != 'Advisor Manager' && user_role != 'Executive' &&  user_role != 'Wholesaler'">
                        <!-- <img src="assets/view-email.png" class="activity-header-action-icon" [matTooltip]="'View Email'" (click)="openActivityEmailPreviewModal(data)" /> -->
                        <!-- <img src="assets/view-record.png" class="activity-header-action-icon" [matTooltip]="'View Email'" (click)="openActivityEmailPreviewModal(activity_data)" /> -->
                        <img src="assets/activity-view-email.png" class="activity-header-action-icon" [matTooltip]="'View Email'" (click)="openActivityEmailPreviewModal(activity_data)" />
                    </div>
                </ng-container>
                <div class="each-activity-header-action-section">
                    <span class="activity-close-icon" (click)="close()">&times;</span>
                </div>
            </div>
        </div>
        <div class="activity-content-section">
            <ng-container *ngIf="activity_data_loaded">
                <div class="activity-details-section">
                    <div class="activity-fields-section">
                        <div class="activity-campaign-details-section">
                            <div>
                                <div class="activity-breadcrumb-section" *ngIf="activity_data.id != null">
                                    <ng-container *ngIf="activity_data.task_type == 'Main Task'">
                                        <span class="activity-breadcrumb-text activity-breadcrumb-primary-text" *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Wholesaler'">{{activity_data.client_name}}</span>
                                        <span class="activity-breadcrumb-text activity-breadcrumb-primary-text" *ngIf="user_role == 'Advisor Manager' || user_role == 'Executive' || user_role == 'Leadership' || user_role == 'Wholesaler'">{{activity_data.advisor_name}}</span>
                                        <span class="activity-breadcrumb-text">
                                            <img src="assets/sub_tasks_open.png" />
                                        </span>
                                        <span class="activity-breadcrumb-text">{{activity_data.name}}</span>
                                    </ng-container>
                                    <ng-container *ngIf="activity_data.task_type != 'Main Task'">
                                        <span class="activity-breadcrumb-text activity-breadcrumb-primary-text" *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership'">{{activity_data.client_name}}</span>
                                        <span class="activity-breadcrumb-text activity-breadcrumb-primary-text" *ngIf="user_role == 'Advisor Manager' || user_role == 'Executive' || user_role == 'Leadership'">{{activity_data.advisor_name}}</span>
                                        <span class="activity-breadcrumb-text">
                                            <img src="assets/sub_tasks_open.png" />
                                        </span>
                                        <!-- <span class="activity-breadcrumb-text activity-breadcrumb-active" (click)="selectSubTask(activity_data.parent_activity_details)">{{activity_data.parent_activity_details.name}}</span> -->
                                        <span class="activity-breadcrumb-text">{{activity_data.parent_activity_details.name}}</span>
                                        <span class="activity-breadcrumb-text">
                                            <img src="assets/sub_tasks_open.png" />
                                        </span>
                                        <span class="activity-breadcrumb-text">{{activity_data.name}}</span>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="activity-action-input-section" *ngIf="activity_data.id != null &&  user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team'">
                                <span class="campaign-label">Campaign</span>
                                <ng-container *ngIf="activity_data.email_campaign || activity_data.portal_campaign || activity_data.message_campaign || activity_data.social_media_campaign">
                                    <!-- <img src="assets/email-campaign.png" [matTooltip]="'Email Notification'" class="campaign-icon" *ngIf="activity_data.email_campaign" /> -->
                                    <img src="assets/email-campaign.png" [matTooltip]="'Email Notification'" class="campaign-icon" (click)="openEmail(activity_data)" />
                                    <img src="assets/portal-campaign.png" [matTooltip]="'Portal Notification'" class="campaign-icon" *ngIf="activity_data.portal_campaign" (click)="openNotificationModal('Portal Campaign', activity_data.portal_notification_content)" />
                                    <img src="assets/message-campaign.png" [matTooltip]="'Message Notification'" class="campaign-icon" *ngIf="activity_data.message_campaign" (click)="openNotificationModal('Message Campaign', activity_data.text_message_content)" />
                                    <img src="assets/social-media-campaign.png" [matTooltip]="'Social Media Notification'" class="campaign-icon" *ngIf="activity_data.social_media_campaign" />
                                </ng-container>
                                <ng-container *ngIf="!activity_data.email_campaign && !activity_data.portal_campaign && !activity_data.message_campaign && !activity_data.social_media_campaign">
                                    <span class="activity-table-tag manual-task-tag">None</span>
                                </ng-container>
                            </div>
                        </div>
                        <div class="new-activity-fields-section">
                            <div class="activity-fields-details-section">
                                <div class="each-activity-details-heading-section">
                                    <div>
                                        <span class="each-activity-details-heading">About Activity</span>
                                    </div>
                                    <div *ngIf="activity_data.id != '' && activity_data.id != null">
                                        <span class="activity-link" (click)="editAboutActivity()" *ngIf="!edit_about_activity">Edit About Activity</span>
                                        <span class="activity-link" (click)="viewAboutActivity()" *ngIf="edit_about_activity">View About Activity</span>
                                    </div>
                                </div>
                                <div *ngIf="!edit_about_activity">
                                    <div class="new-activity-action-input-section">
                                        <p class="activity-action-input-label">Activity Name</p>
                                        <p class="activity-action-input new-activity-fields-section-readable">{{activity_data.name}}</p>
                                    </div>
                                    <div class="new-activity-action-input-section">
                                        <p class="activity-action-input-label">Activity Type</p>
                                        <p class="activity-action-input new-activity-fields-section-readable">{{activity_data.communication_type_name}}</p>
                                        <div style="text-align: right; margin-top: 4px;">
                                            <!-- <ng-container *ngIf="activity_data.communication_type == 10 && user_details.Zoom_connected && activity_data.id != null"> -->
                                            <ng-container *ngIf="activity_data.communication_type == 10">
                                                <!-- <span class="activity-link" (click)="openScheduleMeetingModal('activity', null)">Schedule a meeting</span> -->
                                                <span class="activity-link" (click)="openScheduleMeetingModal('individual-activity', null)">Schedule a meeting</span>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="new-activity-action-input-section">
                                        <p class="activity-action-input-label">Scheduled Date</p>
                                        <p class="activity-action-input new-activity-fields-section-readable">{{activity_data.scheduled_date | date: 'dd MMM yyyy'}}</p>
                                    </div>
                                    <div class="new-activity-action-input-section" *ngIf="user_role == 'Advisor' || user_role == 'AFA' || user_role == 'Relationship Manager'">
                                        <p class="activity-action-input-label">Assign To</p>
                                        <p class="activity-action-input new-activity-fields-section-readable">{{activity_data.afa_name}}</p>
                                    </div>
                                    <div>
                                        <div class="new-activity-action-input-section" style="width: calc(100% - 16px);">
                                            <p class="activity-action-input-label">Activity Description</p>
                                            <p class="activity-action-input new-activity-fields-section-readable" [innerHTML]="activity_data.description" style="min-height: 100px;"></p>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="edit_about_activity">
                                    <div>
                                        <div class="new-activity-action-input-section">
                                            <p class="activity-action-input-label">Activity Name</p>
                                            <input type="text" class="activity-action-input" [(ngModel)]="activity_data.name" [ngClass]="{'input-error-bg': activity_name_error}" />
                                            <p class="input-error" *ngIf="activity_name_error">Activity name is required.</p>
                                        </div>
                                        <div class="new-activity-action-input-section">
                                            <p class="activity-action-input-label">Activity Type</p>
                                            <mat-select class="activity-action-input" [(ngModel)]="activity_data.communication_type" [disabled]="isReadOnly" [ngClass]="{'input-error-bg': activity_channel_error}">
                                                <!-- <mat-option [value]="''">None</mat-option>  -->
                                                <mat-option *ngFor="let communication of communication_type_list" [value]="communication.id" (click)="activity_data.communication_type_name = communication.name">{{ communication.name }}</mat-option>
                                            </mat-select>
                                            <p class="input-error" *ngIf="activity_channel_error">Activity Type is required.</p>
                                            <div style="text-align: right; margin-top: 4px;">
                                                <!-- <ng-container *ngIf="activity_data.communication_type == 10 && user_details.Zoom_connected && activity_data.id != null"> -->
                                                <ng-container *ngIf="activity_data.communication_type == 10">
                                                    <!-- <span class="activity-link" (click)="openScheduleMeetingModal('activity', null)">Schedule a meeting</span> -->
                                                    <span class="activity-link" (click)="openScheduleMeetingModal('individual-activity', null)">Schedule a meeting</span>
                                                </ng-container>
                                            </div>
                                        </div>
                                        <div class="new-activity-action-input-section">
                                            <p class="activity-action-input-label">Scheduled Date</p>
                                            <input
                                                type="text"
                                                class="activity-action-input"
                                                bsDatepicker
                                                placement="bottom"
                                                [(ngModel)]="activity_data.scheduled_date"
                                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                                [disabled]="isReadOnly"
                                                [ngClass]="{'input-error-bg': activity_schedule_date_error}"
                                            />
                                            <p class="input-error" *ngIf="activity_schedule_date_error">Scheduled Date is required.</p>
                                        </div>
                                        <ng-container *ngIf="user_role == 'Advisor' || user_role == 'AFA' || user_role == 'Relationship Manager'">
                                            <div class="new-activity-action-input-section">
                                                <p class="activity-action-input-label">Assign To</p>
                                                <mat-select class="activity-action-input" [(ngModel)]="activity_data.afa_id" [disabled]="isReadOnly" [ngClass]="{'input-error-bg': activity_assignee_error}">
                                                    <mat-option [value]="''">Self</mat-option>
                                                    <mat-option *ngFor="let afa of afa_list" [value]="afa.id" (click)="activity_data.afa_name = afa.first_name + ' ' + afa.last_name">{{ afa.first_name }} {{ afa.last_name }}</mat-option>
                                                </mat-select>
                                                <p class="input-error" *ngIf="activity_assignee_error">Assign To is required.</p>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="new-activity-action-input-section" style="width: calc(100% - 16px);">
                                        <!-- <p class="activity-action-input-label">Notes</p> -->
                                        <p class="activity-action-input-label">Activity Description</p>
                                        <!-- <app-textarea-tagging [value]="activity_data.description" [users]="tagging_users_list" [placeholder]="'Notes ...'" (valueChanged)="activity_data.description = $event"></app-textarea-tagging> -->
                                        <app-textarea-tagging [value]="activity_data.description" [users]="tagging_users_list" [placeholder]="'Activity Description ...'" (valueChanged)="activity_data.description = $event"></app-textarea-tagging>
                                    </div>
                                </div>
                                <!-- <ng-container *ngIf="activity_data.id != null && activity_data.show_action == true">
                                    <div class="each-activity-details-heading-section" style="background: #FF9800;">
                                        <div>
                                            <span class="each-activity-details-heading" style="color: #FFFFFF;">Act Now</span>
                                        </div>
                                    </div>
                                    <div class="activity-quick-actions-section">
                                        <img [src]="activity_data.action_channel" class="activity-quick-actions-image" (click)="activityQuickAction()" />
                                        <ng-container *ngIf="activity_data.action_type == 'Email'">
                                            <img src="assets/send-document.svg" class="activity-quick-actions-image" (click)="openSendProposalModal()" />
                                        </ng-container>
                                    </div>
                                </ng-container> -->
                            </div>
                        </div>
                        <div class="new-activity-fields-section" style="background: #feffd1;" *ngIf="activity_data.id != null &&  user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership'">
                            <div class="activity-fields-details-section">
                                <div class="each-activity-details-heading-section">
                                    <div>
                                        <span class="each-activity-details-heading">Opportunity Insights</span>
                                    </div>
                                </div>
                                <div>
                                    <div class="new-activity-action-input-section">
                                        <p class="activity-action-input-label">AI Rank</p>
                                        <p class="activity-action-input new-activity-fields-section-readable">{{activity_data.ai_rank}}</p>
                                    </div>
                                    <div class="new-activity-action-input-section">
                                        <p class="activity-action-input-label">Opportunity</p>
                                        <p class="activity-action-input new-activity-fields-section-readable">{{activity_data.opportunity_value}}</p>
                                    </div>
                                    <div class="new-activity-action-input-section">
                                        <p class="activity-action-input-label">Closure Days</p>
                                        <p class="activity-action-input new-activity-fields-section-readable">{{activity_data.predicted_closure_days}}</p>
                                    </div>
                                    <div class="new-activity-action-input-section">
                                        <p class="activity-action-input-label">Preferred Channel</p>
                                        <p class="activity-action-input new-activity-fields-section-readable">{{activity_data.preferred_channel}}</p>
                                    </div>
                                    <div>
                                        <div class="new-activity-action-input-section" style="width: calc(100% - 16px);">
                                            <p class="activity-action-input-label">Objective</p>
                                            <p class="activity-action-input new-activity-fields-section-readable">{{activity_data.objective}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
 

                        <!-- <div class="new-activity-fields-section" *ngIf="activity_data.id != null" style="background: #DFE9F4;"> -->
                        <div class="new-activity-fields-section" style="background: #DFE9F4;">
                            <div class="each-activity-details-heading-section">
                                <div>
                                    <span class="each-activity-details-heading">Act Now</span>
                                </div>
                            </div>
                            <div class="activity-quick-actions-section">
                                <img src="assets/virtual-meeting-new.png" class="activity-quick-actions-image disable-images" (click)="activityQuickAction()" [ngClass]="{'enable-images': (activity_data.action_type == 'Meeting'  && activity_data.action_value != null && activity_data.action_value != '')}" [matTooltip]="'Launch Meeting'" />

                                <!-- <img src="assets/email-new.png" class="activity-quick-actions-image disable-images" (click)="activityQuickAction()" [ngClass]="{'enable-images': (activity_data.action_type == 'Email'  && activity_data.action_value != null && activity_data.action_value != '')}" [matTooltip]="'Send Email'" /> -->
                                <img src="assets/email-new.png" class="activity-quick-actions-image disable-images" (click)="sendEmail(activity_data.email_value)" [ngClass]="{'enable-images': (activity_data.email_value != ''  && activity_data.email_value != null)}" [matTooltip]="'Send Email'" />

                                <!-- <img src="assets/phone-new.png" class="activity-quick-actions-image disable-images" (click)="activityQuickAction()" [ngClass]="{'enable-images': (activity_data.action_type == 'Phone'  && activity_data.action_value != null && activity_data.action_value != '')}" [matTooltip]="'Phone'" /> -->
                                <img src="assets/phone-new.png" class="activity-quick-actions-image disable-images" (click)="sendPhone(activity_data.phone_value)" [ngClass]="{'enable-images': (activity_data.phone_value == ''  && activity_data.phone_value != null)}" [matTooltip]="'Phone'" />

                                <!-- <img src="assets/send-document.svg" class="activity-quick-actions-image" (click)="openSendProposalModal()" [matTooltip]="'Send Document'" *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 1 || activity_data.activity_type == 2)" /> -->
                                <img src="assets/send-document.svg" class="activity-quick-actions-image" (click)="openSendProposalModal()" [matTooltip]="'Send Document'" *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self')))" />

                                <img src="assets/close-deal.svg" class="activity-quick-actions-image" (click)="openCloseDealModal()" [matTooltip]="'Capture Results'" *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 1 || activity_data.activity_type == 2)" />

                                <img src="assets/close-deal.svg" class="activity-quick-actions-image" (click)="openChangeOutcomeModal()" [matTooltip]="'Capture Results'" *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 3 || activity_data.activity_type == 5)" />

                                 <img src="assets/close-deal.svg" class="activity-quick-actions-image" (click)="openCaptureresultsModal()" [matTooltip]="'Capture Results'" *ngIf="user_role == 'Wholesaler' || user_role == 'Leadership'" />

                            </div>
                        </div>

                        <div class="new-activity-fields-section">
                            <div class="each-activity-details-heading-section">
                                <div>
                                    <span class="each-activity-details-heading">Activity/Meeting Notes</span>
                                </div>
                            </div>
                            <div>
                                <div class="new-activity-action-input-section">
                                    <p class="activity-action-input-label">Activity Status</p>
                                    <!-- <mat-select class="activity-action-input" [(ngModel)]="activity_data.status" (selectionChange)="saveActivityDirectActions('status', activity_data.status, 'text')" [disabled]="isReadOnly"
                                    [ngClass]="{'input-error-bg': activity_status_error}"> -->
                                    <mat-select class="activity-action-input" [(ngModel)]="activity_data.status" [disabled]="isReadOnly"
                                    [ngClass]="{'input-error-bg': activity_status_error}">
                                        <!-- <mat-option [value]="''">None</mat-option>  -->
                                        <mat-option *ngFor="let status of status_list" [value]="status.id">{{status.name}}</mat-option>
                                    </mat-select>
                                    <p class="input-error" *ngIf="activity_status_error">Status is required.</p>
                                </div>
                                <div class="new-activity-action-input-section">
                                    <p class="activity-action-input-label" *ngIf="activity_data.status != 11">Actual Date</p>
                                    <p class="activity-action-input-label" *ngIf="activity_data.status == 11">Rescheduled Date</p>
                                    <!-- <input
                                        type="text"
                                        class="activity-action-input"
                                        bsDatepicker
                                        placement="bottom"
                                        [(ngModel)]="activity_data.actual_date"
                                        [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                        (ngModelChange)="saveActivityDirectActions('actual_date', activity_data.actual_date, 'date')"
                                        [disabled]="isReadOnly"
                                    /> -->
                                    <input
                                        type="text"
                                        class="activity-action-input"
                                        bsDatepicker
                                        placement="bottom"
                                        [(ngModel)]="activity_data.actual_date"
                                        [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                        [disabled]="isReadOnly"
                                    />
                                    <p class="input-error" *ngIf="activity_actual_date_error && activity_data.status != 11">Actual Date is required.</p>
                                    <p class="input-error" *ngIf="activity_actual_date_error && activity_data.status == 11">Rescheduled Date is required.</p>
                                </div>

                                <div class="new-activity-action-input-section" *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive'">
                                    <p class="activity-action-input-label">Response Type</p>
                                    <!-- <p class="activity-action-input-label" *ngIf="data.source == 'csa'">Client Interest</p>
                                    <p class="activity-action-input-label" *ngIf="data.source == 'lpa'">Lead Interest</p>
                                    <p class="activity-action-input-label" *ngIf="data.source == 'wa'">Advisor Interest</p> -->
                                    <mat-select class="activity-action-input" [(ngModel)]="activity_data.capture_response.response_status"
                                    [ngClass]="{'input-error-bg': capture_response_data_errors.response_status}" [disabled]="isReadOnly">
                                        <!-- <mat-option [value]="''" *ngIf="data.source == 'csa'">Select Client Interest</mat-option>
                                        <mat-option [value]="''" *ngIf="data.source == 'lpa'">Select Lead Interest</mat-option>
                                        <mat-option [value]="''" *ngIf="data.source == 'wa'">Select Advisor Interest</mat-option> -->
                                        <mat-option [value]="''">Select Response Type</mat-option>
                                        <mat-option *ngFor="let response_option of response_options_list" [value]="response_option.name">{{ response_option.name }}</mat-option>
                                    </mat-select>
                                    <!-- <p class="input-error" *ngIf="capture_response_data_errors.response_status && data.source == 'csa'">Client Interest is required.</p>
                                    <p class="input-error" *ngIf="capture_response_data_errors.response_status && data.source == 'lpa'">Lead Interest is required.</p>
                                    <p class="input-error" *ngIf="capture_response_data_errors.response_status && data.source == 'wa'">Advisor Interest is required.</p> -->
                                    <p class="input-error" *ngIf="capture_response_data_errors.response_status">Response Type is required.</p>
                                </div>
                            </div>
                            <div>
                                <div class="capture-response-input-section" style="width: calc(100% - 16px);">
                                    <p class="capture-response-input-label">Notes</p>
                                    <app-textarea-tagging [value]="activity_data.capture_response.response_comments" [users]="tagging_users_list" [placeholder]="'Notes ...'" (valueChanged)="activity_data.capture_response.response_comments = $event"></app-textarea-tagging>
                                    <p class="input-error" *ngIf="capture_response_data_errors.response_comments">Notes is Required.</p>
                                </div>
                            </div>
                        </div>

                        <div class="new-activity-fields-section">
                            <div class="each-activity-details-heading-section">
                                <div>
                                    <span class="each-activity-details-heading">Action Items</span>
                                </div>
                            </div>

                            <table class="activity-inner-table">
                                <thead>
                                    <tr>
                                        <th>Activity Name</th>
                                        <th>Activity Type</th>
                                        <th>Scheduled Date</th>
                                        <th *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team' && user_role != 'Wholesaler'">Assign To</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let follow_up_task of activity_data.followup_activities; let index = index;">
                                        <tr *ngIf="follow_up_task_index != index">
                                            <td>{{follow_up_task.name}}</td>
                                            <td>{{follow_up_task.channel_name}}</td>
                                            <td>{{follow_up_task.scheduled_date | date: "dd MMM yyyy"}}</td>
                                            <td *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team' && user_role != 'Wholesaler'">
                                                <span *ngIf="follow_up_task.afa_name == '' || follow_up_task.afa_name == null">Self</span>
                                                <span *ngIf="follow_up_task.afa_name != '' && follow_up_task.afa_name != null">{{follow_up_task.afa_name}}</span>
                                            </td>
                                            <td>
                                              <img src="assets/edit-client.png" class="page-table-actions" (click)="followUpTaskOperations(follow_up_task, index, 'Edit')" />
                                              <img src="assets/delete-icon.png" class="page-table-actions" (click)="deleteFollowUpTask(index)" *ngIf="!follow_up_task.id" />
                                              <img src="assets/ic-targets.png"  class="page-table-actions" (click)="openScheduleMeetingModal('action-item', index)" *ngIf="follow_up_task.channel == 10" />
                                          </td>
                                        </tr>
                                        <tr *ngIf="follow_up_task_index == index">
                                            <td>
                                                <input type="text" class="page-inner-table-input" [(ngModel)]="follow_up_task_data.name" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.name}"/>
                                            </td>
                                            <td>
                                                <mat-select class="page-inner-table-input" [(ngModel)]="follow_up_task_data.channel" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.channel}">
                                                    <mat-option [value]="''">Select Activity Type</mat-option>
                                                    <mat-option *ngFor="let communication of communication_type_list" [value]="communication.id" (click)="follow_up_task_data.channel_name = communication.name">{{ communication.name }}</mat-option>
                                                </mat-select>
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    class="page-inner-table-input"
                                                    bsDatepicker
                                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                                    [(ngModel)]="follow_up_task_data.scheduled_date"
                                                    [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.scheduled_date}"
                                                />
                                            </td>
                                            <td *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team'">
                                                <!-- <mat-select class="page-inner-table-input" [(ngModel)]="follow_up_task_data.status" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.status}">
                                                <mat-option [value]="''">Select Status</mat-option>
                                                <mat-option *ngFor="let status of status_list" [value]="status.id" (click)="follow_up_task_data.status_name = status.name">{{status.name}}</mat-option>
                                            </mat-select> -->
                                            <mat-select class="page-inner-table-input" [(ngModel)]="follow_up_task_data.afa_id" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.afa_id}">
                                                <mat-option [value]="''">Self</mat-option>
                                                <mat-option *ngFor="let afa of afa_list" [value]="afa.id" (click)="follow_up_task_data.afa_name = afa.first_name + ' ' + afa.last_name">{{ afa.afa.first_name }} {{ afa.last_name }}</mat-option>
                                            </mat-select>
                                            </td>
                                            <td>
                                              <img src="assets/activity-save.png" class="page-table-actions" (click)="saveFollowUpTask()" />
                                              <img src="assets/activity-cancel.png" class="page-table-actions" (click)="resetFollowUpTask()" />
                                          </td>
                                        </tr>
                                    </ng-container>
                                    <tr *ngIf="follow_up_task_type == 'Add' && follow_up_task_index == null">
                                        <td>
                                            <input type="text" class="page-inner-table-input" [(ngModel)]="follow_up_task_data.name" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.name}"/>
                                        </td>
                                        <td>
                                            <mat-select class="page-inner-table-input" [(ngModel)]="follow_up_task_data.channel" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.channel}">
                                                <mat-option [value]="''">Select Activity Type</mat-option>
                                                <mat-option *ngFor="let communication of communication_type_list" [value]="communication.id" (click)="follow_up_task_data.channel_name = communication.name">{{ communication.name }}</mat-option>
                                            </mat-select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="page-inner-table-input"
                                                bsDatepicker
                                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                                [(ngModel)]="follow_up_task_data.scheduled_date"
                                                [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.scheduled_date}"
                                            />
                                        </td>
                                        <td *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team'">
                                            <!-- <mat-select class="page-inner-table-input" [(ngModel)]="follow_up_task_data.status" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.status}">
                                                <mat-option [value]="''">Select Status</mat-option>
                                                <mat-option *ngFor="let status of status_list" [value]="status.id" (click)="follow_up_task_data.status_name = status.name">{{status.name}}</mat-option>
                                            </mat-select> -->
                                            <mat-select class="page-inner-table-input" [(ngModel)]="follow_up_task_data.afa_id" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.afa_id}">
                                                <mat-option [value]="''">Self</mat-option>
                                                <mat-option *ngFor="let afa of afa_list" [value]="afa.id" (click)="follow_up_task_data.afa_name = afa.first_name + ' ' + afa.last_name">{{ afa.first_name }} {{ afa.last_name }}</mat-option>
                                            </mat-select>
                                        </td>
                                        <td>
                                          <img src="assets/activity-save.png" class="page-table-actions" (click)="saveFollowUpTask()" />
                                          <img src="assets/activity-cancel.png" class="page-table-actions" (click)="resetFollowUpTask()" />
                                      </td>
                                    </tr>
                                    <tr *ngIf="follow_up_task_type == '' &&follow_up_task_index == null">
                                        <td>
                                           <!-- <span style="cursor: pointer;" (click)="followUpTaskOperations(follow_up_task_data, index, 'Add')">+ Add New Action Item</span> -->
                                           <span style="cursor: pointer;" (click)="followUpTaskOperations(follow_up_task_data, null, 'Add')">+ Add New Action Item</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- <div class="new-activity-action-section" style="padding-right: 16px;">
                            <button class="activity-more-action" (click)="show_capture_response_section = true; show_follow_up_tasks = false;">Capture Meeting Notes</button>
                            <ng-container *ngIf="activity_data.task_type == 'Main Task'">
                                <button class="activity-more-action" (click)="addFollowupTask()" *ngIf="!show_follow_up_tasks">Add Follow Up Task</button>
                                <button class="activity-more-action" (click)="show_follow_up_tasks = false;" *ngIf="show_follow_up_tasks">Hide Follow Up Task</button>
                            </ng-container>
                        </div> -->

                        <ng-container *ngIf="show_capture_response_section">
                            <div class="each-activity-details-heading-section">
                                <div>
                                    <span class="each-activity-details-heading">Capture Meeting Notes</span>
                                </div>
                            </div>
                            <div class="capture-response-input-section">
                                <p class="capture-response-input-label">Response</p>


                              <!-- <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_status" (selectionChange)="showActivities($event.value)"> -->
                                <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_status">
                                  <mat-option [value]="''">Select Response</mat-option>
                                  <mat-option *ngFor="let response_option of response_options_list" [value]="response_option.name" (click)="showActivities(response_option)">{{ response_option.name }}</mat-option>
                              </mat-select>

                                <!-- <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_status">
                                    <mat-option [value]="''">Select Response</mat-option>
                                    <mat-option [value]="'Interested'">Interested</mat-option>
                                    <mat-option [value]="'Not Interested'">Not Interested</mat-option>
                                    <mat-option [value]="'No Response'">No Response</mat-option>
                                </mat-select> -->

                                <p class="input-error" *ngIf="capture_response_data_errors.response_status">Response is Required.</p>
                            </div>
                            <div class="capture-response-input-section">
                                <p class="capture-response-input-label">Response Channel</p>
                                <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_channel">
                                    <mat-option [value]="''">Select Response Channel</mat-option>
                                    <mat-option *ngFor="let communication_type of communication_type_list" [value]="communication_type.id">{{communication_type.name}}</mat-option>
                                </mat-select>
                                <p class="input-error" *ngIf="capture_response_data_errors.response_channel">Response Channel is Required.</p>
                            </div>
                            <div class="capture-response-input-section">
                                <p class="capture-response-input-label">Response Date</p>
                                <input
                                    type="text"
                                    class="capture-response-input"
                                    bsDatepicker
                                    placement="left"
                                    [(ngModel)]="activity_data.capture_response.response_capture_date"
                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                />
                                <p class="input-error" *ngIf="capture_response_data_errors.response_capture_date">Response Date is Required.</p>
                            </div>
                            <div>
                                <div class="capture-response-input-section" style="width: 100%;">
                                    <p class="capture-response-input-label">Notes</p>
                                    <app-textarea-tagging [value]="activity_data.capture_response.response_comments" [users]="tagging_users_list" [placeholder]="'Notes ...'" (valueChanged)="activity_data.capture_response.response_comments = $event"></app-textarea-tagging>
                                    <p class="input-error" *ngIf="capture_response_data_errors.response_comments">Notes is Required.</p>
                                </div>
                            </div>

                            <div>
                                <div class="capture-response-input-section" style="width: 100%;">
                                    <mat-checkbox [(ngModel)]="activity_data.capture_response.pause_campaign">Do you want to pause the remaining campaign activities?</mat-checkbox>
                                </div>
                            </div>




                            <div class="each-activity-details-action-section">
                                <button class="page-modal-primary-button" (click)="validateCaptureResponse()">Capture</button>
                                <button class="page-modal-secondary-button"  (click)="show_capture_response_section = false; show_follow_up_tasks = false;">Cancel</button>
                            </div>
                        </ng-container>

                        <!-- <ng-container *ngIf="show_follow_up_tasks">
                            <div class="each-activity-details-heading-section">
                                <div>
                                    <span class="each-activity-details-heading">Follow Up Tasks</span>
                                </div>
                            </div>

                            <table class="activity-inner-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Channel</th>
                                        <th>Scheduled Date</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let follow_up_task of follow_up_tasks; let index = index;">
                                        <tr *ngIf="follow_up_task_index != index">
                                            <td>{{follow_up_task.name}}</td>
                                            <td>{{follow_up_task.channel_name}}</td>
                                            <td>{{follow_up_task.scheduled_date | date: "dd MMM yyyy"}}</td>
                                            <td>{{follow_up_task.status_name}}</td>
                                            <td>
                                              <img src="assets/edit-client.png" class="page-table-actions" (click)="followUpTaskOperations(follow_up_task, index, 'Edit')" />
                                              <img src="assets/delete-icon.png" class="page-table-actions" (click)="deleteFollowUpTask(index)" />
                                          </td>
                                        </tr>
                                        <tr *ngIf="follow_up_task_index == index">
                                            <td>
                                                <input type="text" class="page-inner-table-input" [(ngModel)]="follow_up_task_data.name" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.name}"/>
                                            </td>
                                            <td>
                                                <mat-select class="page-inner-table-input" [(ngModel)]="follow_up_task_data.channel" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.channel}">
                                                    <mat-option [value]="''">Select Channel</mat-option>
                                                    <mat-option *ngFor="let communication of communication_type_list" [value]="communication.id" (click)="follow_up_task_data.channel_name = communication.name">{{ communication.name }}</mat-option>
                                                </mat-select>
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    class="page-inner-table-input"
                                                    bsDatepicker
                                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                                    [(ngModel)]="follow_up_task_data.scheduled_date"
                                                    [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.scheduled_date}"
                                                />
                                            </td>
                                            <td>
                                                <mat-select class="page-inner-table-input" [(ngModel)]="follow_up_task_data.status" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.status}">
                                                    <mat-option [value]="''">Select Status</mat-option>
                                                    <mat-option *ngFor="let status of status_list" [value]="status.id" (click)="follow_up_task_data.status_name = status.name">{{status.name}}</mat-option>
                                                </mat-select>
                                            </td>
                                            <td>
                                              <img src="assets/activity-save.png" class="page-table-actions" (click)="saveFollowUpTask()" />
                                              <img src="assets/activity-cancel.png" class="page-table-actions" (click)="resetFollowUpTask()" />
                                          </td>
                                        </tr>
                                    </ng-container>
                                    <tr *ngIf="follow_up_task_type == 'Add' && follow_up_task_index == null">
                                        <td>
                                            <input type="text" class="page-inner-table-input" [(ngModel)]="follow_up_task_data.name" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.name}"/>
                                        </td>
                                        <td>
                                            <mat-select class="page-inner-table-input" [(ngModel)]="follow_up_task_data.channel" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.channel}">
                                                <mat-option [value]="''">Select Channel</mat-option>
                                                <mat-option *ngFor="let communication of communication_type_list" [value]="communication.id" (click)="follow_up_task_data.channel_name = communication.name">{{ communication.name }}</mat-option>
                                            </mat-select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="page-inner-table-input"
                                                bsDatepicker
                                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                                [(ngModel)]="follow_up_task_data.scheduled_date"
                                                [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.scheduled_date}"
                                            />
                                        </td>
                                        <td>
                                            <mat-select class="page-inner-table-input" [(ngModel)]="follow_up_task_data.status" [ngClass]="{'page-inner-table-input-error': follow_up_task_data_errors.status}">
                                                <mat-option [value]="''">Select Status</mat-option>
                                                <mat-option *ngFor="let status of status_list" [value]="status.id" (click)="follow_up_task_data.status_name = status.name">{{status.name}}</mat-option>
                                            </mat-select>
                                        </td>
                                        <td>
                                          <img src="assets/activity-save.png" class="page-table-actions" (click)="saveFollowUpTask()" />
                                          <img src="assets/activity-cancel.png" class="page-table-actions" (click)="resetFollowUpTask()" />
                                      </td>
                                    </tr>
                                    <tr *ngIf="follow_up_task_type == '' &&follow_up_task_index == null">
                                        <td>
                                           <span style="cursor: pointer;" (click)="followUpTaskOperations(follow_up_task_data, index, 'Add')">+ Add New Follow Up Task</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </ng-container> -->

                        <div>
                            <mat-checkbox [(ngModel)]="activity_data.stop_activity">Mark pending and in-progress activities as not required?</mat-checkbox>
                        </div>

                        <div class="new-activity-action-section">
                            <!-- <button class="new-activity-button" (click)="saveActivityData()">Save</button> -->
                            <button class="new-activity-button" (click)="checkActivityData()" *ngIf="!activity_save_loader">Save Activity</button>
                            <button class="new-activity-button" *ngIf="activity_save_loader">Saving Activity ...</button>
                        </div>

                        <!-- Intentional Condition to hide the Sub Tasks for now -->
                        <div *ngIf="show_sub_tasks">
                            <ng-container *ngIf="activity_data.id != null">
                                <ng-container *ngIf="activity_data.task_type == 'Main Task'">
                                    <div class="each-activity-details-section">
                                        <div class="each-activity-details-heading-section">
                                            <div>
                                                <span class="each-activity-details-heading">Sub Tasks</span>
                                            </div>
                                        </div>
                                        <div class="subtask-information-section">
                                        <p>
                                            In order to complete this activity one or more sub tasks may be required.
                                        </p>
                                        <p>
                                            <b>Example:</b> If activity is sending brochure to client, you may need help of marketing team to create the brochures.
                                        </p>
                                        </div>
                                        <ng-container *ngIf="sub_tasks_data_loaded">
                                            <table class="activity-inner-table">
                                                <thead>
                                                    <tr>
                                                        <th>Activity Name</th>
                                                        <th>Activity Type</th>
                                                        <th>Scheduled Date</th>
                                                        <th>Assigned To</th>
                                                        <th>Activity Status</th>
                                                        <th>Actions</th>
                                                        <!-- <th>Activity Type</th> -->
                                                        <!-- <th>Response</th> -->
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let sub_task of sub_tasks_data">
                                                        <td>
                                                            <p class="sub-activity-name automated-sub-activity-name" (click)="selectSubTask(sub_task)">{{sub_task.name}}</p>
                                                        </td>
                                                        <td>{{sub_task.communication_type_name}}</td>
                                                        <td>{{sub_task.scheduled_date | date: "dd MMM yyyy"}}</td>
                                                        <td>{{sub_task.afa_name}}</td>
                                                        <td>
                                                            <!-- <span class="activity-table-tag" [ngClass]="{'pending-status-tag': sub_task.status_name == 'Pending', 'completed-status-tag': sub_task.status_name == 'Completed', 'in-progress-status-tag': sub_task.status_name == 'In Progress', 'not-required-status-tag': sub_task.status_name == 'Not Required', 'cancelled-status-tag': sub_task.status_name == 'Cancelled'}">{{sub_task.status_name}}</span> -->
                                                            <span class="activity-table-tag" [ngClass]="{'pending-status-tag': sub_task.status_name == 'Pending', 'completed-status-tag': sub_task.status_name == 'Completed', 'in-progress-status-tag': sub_task.status_name == 'In Progress', 'not-required-status-tag': sub_task.status_name == 'Not Required', 'cancelled-status-tag': sub_task.status_name == 'Cancelled', 'manual-task-tag': sub_task.status_name == 'Unsubscribed', 'medium-importance-tag': sub_task.status_name == 'Not Started'}">{{sub_task.status_name}}</span>
                                                        </td>
                                                        <td>
                                                        <ng-container *ngIf="sub_task.afa_name != 'Self'">
                                                            <button class="page-modal-primary-button" (click)="notifyAssistant(sub_task)">Notify</button>
                                                            <button class="page-modal-primary-button" (click)="notifyStatusUpdate(sub_task)">Notify Updated Status</button>
                                                        </ng-container>
                                                        <ng-container *ngIf="sub_task.afa_name == 'Self'">
                                                            <span>-</span>
                                                        </ng-container>
                                                    </td>
                                                        <!-- <td>
                                                            <span *ngIf="(sub_task.activity_type != 1) && (sub_task.activity_type != 4) && (sub_task.activity_type != 5)" class="activity-table-tag manual-task-tag">Manual</span>
                                                            <span *ngIf="(sub_task.activity_type == 1) || (sub_task.activity_type == 4) || (sub_task.activity_type == 5)"class="activity-table-tag automated-task-tag">Automated</span>
                                                        </td> -->

                                                        <!-- <td>
                                                            <span [innerHTML]="sub_task.capture_response.response_comments"></span>
                                                        </td> -->
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <ng-container *ngIf="!isReadOnly">
                                                <div class="each-activity-details-button-section" *ngIf="!show_add_sub_task_view">
                                                    <!-- <button class="activity-more-action" (click)="addSubTask()" style="margin-right: 0;">+ Add New Sub Task</button> -->
                                                    <button class="activity-more-action" (click)="addManualSubTask()" style="margin-right: 0;">+ Add New Sub Task</button>
                                                </div>

                                                <div *ngIf="show_add_sub_task_view">
                                                    <div class="activity-editable-input-section">
                                                        <input type="text" class="add-activity-input" [(ngModel)]="sub_task_name" />
                                                    </div>
                                                    <div class="activity-editable-action-section" *ngIf="!save_sub_task_loader">
                                                        <img src="assets/activity-save.png" class="activity-editable-action-icon" (click)="saveSubTask()" />
                                                        <img src="assets/activity-cancel.png" class="activity-editable-action-icon" (click)="cancelSubTask()" />
                                                    </div>
                                                    <div class="activity-editable-action-section" *ngIf="save_sub_task_loader">
                                                        <img src="assets/activity-save.png" class="activity-editable-action-icon" />
                                                        <img src="assets/activity-cancel.png" class="activity-editable-action-icon" />
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="!sub_tasks_data_loaded">
                                            <app-loader [loading_text]="'Loading Sub Tasks'"></app-loader>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>


                        <div class="activity-accordion-section" *ngIf="activity_data.id != null">
                            <div class="activity-accordion-header-section" (click)="show_additional_info = !show_additional_info">
                                <span>Additional Information</span>
                                <img src="assets/up_arrow_chat.png" class="profile-accordion-icon" *ngIf="show_additional_info" />
                                <img src="assets/down_arrow_chat.png" class="profile-accordion-icon" *ngIf="!show_additional_info" />
                            </div>
                            <div class="activity-accordion-content-section" *ngIf="show_additional_info">
                                <div *ngIf="activity_data.id != null">
                                    <!-- <div class="each-activity-details-heading-section">
                                        <div>
                                            <span class="each-activity-details-heading">Activity</span>
                                        </div>
                                    </div> -->
                                    <div class="activity-info-tabs-section">
                                        <!-- <span class="show-activity-text">Show:</span> -->
                                        <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Comments'}" (click)="activity_tab_selected = 'Comments'" style="margin-left: 0;">
                                            <span>
                                                Comments
                                                <span *ngIf="activity_data.comments.length > 0">({{activity_data.comments.length}})</span>
                                            </span>
                                        </div>
                                        <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Documents'}" (click)="activity_tab_selected = 'Documents'" *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team' && user_role != 'Wholesaler'">
                                            <span>
                                                Documents
                                                <span *ngIf="activity_data.documents.length > 0">({{activity_data.documents.length}})</span>
                                            </span>
                                        </div>
                                        <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Attachments'}" (click)="activity_tab_selected = 'Attachments'">
                                            <span>
                                                Attachments
                                                <span *ngIf="activity_data.attachments.length > 0">({{activity_data.attachments.length}})</span>
                                            </span>
                                        </div>
                                        <!-- <ng-container *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 1 || activity_data.activity_type == 2)">
                                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Close Deal'}" (click)="activity_tab_selected = 'Close Deal'">
                                                <span>Close Deal</span>
                                            </div>
                                        </ng-container> -->
                                        <!-- <ng-container *ngIf="((user_role == 'Advisor') || (user_role == 'Relationship Manager') || (user_role == 'AFA' && (activity_data.afa_name == '' || activity_data.afa_name == null || activity_data.afa_name == 'Self'))) && (activity_data.activity_type == 3 || activity_data.activity_type == 5)">
                                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Change Outcome'}" (click)="activity_tab_selected = 'Change Outcome'">
                                                <span>Change Outcome</span>
                                            </div>
                                        </ng-container> -->
                                        <!-- <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'History'}" (click)="activity_tab_selected = 'History'">
                                            <span>
                                                History
                                                <span *ngIf="activity_data.past_activities.length > 0">({{activity_data.past_activities.length}})</span>
                                            </span>
                                        </div> -->
                                        <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Activity History'}" (click)="activity_tab_selected = 'Activity History'">
                                            <span>
                                                Activity History
                                                <span *ngIf="activity_data.past_activities.length > 0">({{activity_data.past_activities.length}})</span>
                                            </span>
                                        </div>
                                        <!-- <ng-container *ngIf="user_role != 'Advisor Manager'">
                                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Campaign History'}" (click)="activity_tab_selected = 'Campaign History'">
                                                <span>
                                                    Campaign History
                                                    <span *ngIf="activity_data.campaign_history.length > 0">({{activity_data.campaign_history.length}})</span>
                                                </span>
                                            </div>
                                        </ng-container> -->
                                        <ng-container *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team'">
                                            <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Campaign Channel'}" (click)="activity_tab_selected = 'Campaign Channel'">
                                                <span>
                                                    Campaign Channel
                                                    <span *ngIf="activity_data.campaign_history.length > 0">({{activity_data.campaign_history.length}})</span>
                                                </span>
                                            </div>
                                        </ng-container>
                                        <!-- <div class="each-activity-info-tab" [ngClass]="{'each-activity-tab-selcted': activity_tab_selected == 'Capture Response'}" (click)="activity_tab_selected = 'Capture Response'">
                                            <span>
                                                Capture Response
                                            </span>
                                        </div> -->
                                    </div>
                                </div>
                                <ng-container *ngIf="activity_data.id != null">

                                    <ng-container *ngIf="activity_tab_selected == 'Documents'">
                                        <ng-container>
                                            <table class="attachments-table">
                                                <thead>
                                                    <tr>
                                                        <th *ngIf="!isReadOnly">Actions</th>
                                                        <th>Document Sent Date</th>
                                                        <th>Product</th>
                                                        <th>Objective</th>
                                                    </tr>
                                                </thead>
                                                <tbody *ngIf="activity_data.documents.length > 0">
                                                    <ng-container *ngFor="let document of activity_data.documents">
                                                        <tr>
                                                            <td *ngIf="!isReadOnly">
                                                                <img src="assets/view-tasks.png" class="client-table-icon" (click)="viewProposal(document)" style="margin-right: 4px;" />
                                                            </td>
                                                            <td>{{document.proposal_sent_date | date: "dd MMM yyyy"}}</td>
                                                            <td>{{document.objective}}</td>
                                                            <td>{{document.product_name}}</td>
                                                        </tr>
                                                    </ng-container>
                                                </tbody>
                                            </table>
                                        </ng-container>
                                        <div class="each-activity-details-button-section">
                                            <button class="activity-more-action" (click)="openSendProposalModal()" style="margin-right: 0;">Send New Document</button>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="activity_tab_selected == 'Comments'">

                                        <ng-container *ngIf="show_comments_operation_section == null && !isReadOnly">
                                            <ng-container *ngTemplateOutlet="commentsFieldsSection;"></ng-container>
                                        </ng-container>

                                        <ng-container *ngFor="let comment of activity_data.comments; let commentIndex = index">
                                            <div class="each-comment-section" *ngIf="show_comments_operation_section != commentIndex">
                                                <div class="comment-details-section">
                                                    <div class="comment-author-circle">
                                                        <span>{{comment.commented_by_name[0]}}</span>
                                                    </div>
                                                    <div>
                                                        <span class="comment-author-name">{{comment.commented_by_name}}</span>
                                                        <span class="comment-date">{{comment.comment_date | date: "MMM d, y, h:mm:ss a"}}</span>
                                                    </div>
                                                </div>
                                                <div class="comment-content-section">
                                                    <p class="comment-content-text" [innerHTML]="comment.description"></p>

                                                    <div class="comment-actions-section" *ngIf="!isReadOnly">
                                                        <span class="comment-action-link" (click)="commentsOperation(comment, 'Edit', commentIndex)">Edit</span>
                                                        <!-- <span class="comment-action-link" (click)="deleteComment(comment, commentIndex)">Delete</span> -->
                                                        <span class="comment-action-link" (click)="removeComment(comment, commentIndex)">Delete</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <ng-container *ngIf="show_comments_operation_section == commentIndex">
                                                <ng-container *ngTemplateOutlet="commentsFieldsSection;"></ng-container>
                                                <!-- <div class="each-comment-section">
                                                    <ng-container *ngTemplateOutlet="commentsSection;"></ng-container>
                                                    <div class="page-modal-footer-section">
                                                        <button class="page-modal-primary-button" (click)="saveComment()">Save</button>
                                                        <button class="page-modal-secondary-button" (click)="resetCommentsData()">Cancel</button>
                                                    </div>
                                                </div> -->
                                            </ng-container>
                                        </ng-container>

                                        <!-- <ng-container>
                                            <div class="each-comment-section" *ngIf="comment_operation_type == '' && !isReadOnly">
                                                <button class="add-activity-action-primary" style="margin-left: 0;" (click)="commentsOperation(comment_data, 'Add', null)">Add Comment</button>
                                            </div>
                                            <ng-container *ngIf="show_comments_operation_section == null">
                                                <div class="each-comment-section">
                                                    <ng-container *ngTemplateOutlet="commentsSection;"></ng-container>
                                                    <div class="page-modal-footer-section">
                                                        <button class="page-modal-primary-button" (click)="saveComment()">Save</button>
                                                        <button class="page-modal-secondary-button" (click)="resetCommentsData()">Cancel</button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container> -->

                                    </ng-container>

                                    <ng-container *ngIf="activity_tab_selected == 'Attachments'">
                                        <ng-container>
                                            <table class="attachments-table">
                                                <thead>
                                                    <tr>
                                                        <th *ngIf="!isReadOnly">Actions</th>
                                                        <th>Attachment Name</th>
                                                        <th>Comments</th>
                                                    </tr>
                                                </thead>
                                                <tbody *ngIf="activity_data.attachments.length > 0">
                                                    <ng-container *ngFor="let attachment of activity_data.attachments; let attachmentIndex = index;">
                                                        <tr *ngIf="attachment_operation_index != attachmentIndex">
                                                            <td *ngIf="!isReadOnly">
                                                                <img src="assets/attachment-edit.png" [matTooltip]="'Upload Atttachmentt'" class="each-attachment-icon" (click)="openAttachmentOperation(attachment, 'Edit', attachmentIndex)" />
                                                                <img src="assets/attachment-download.png" [matTooltip]="'Download Atttachmentt'" class="each-attachment-icon" (click)="downloadAttachment(attachment)" />
                                                                <!-- Remove Delete <img src="assets/attachment-delete.png" [matTooltip]="'Delete Atttachmentt'" class="each-attachment-icon" (click)="removeAttachment(attachment, attachmentIndex)" /> -->
                                                            </td>
                                                            <td>
                                                                <p>{{attachment.attachment_filename}}</p>
                                                            </td>
                                                            <td>
                                                                <p [innerHTML]="attachment.comments"></p>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="attachment_operation_index == attachmentIndex">
                                                            <td colspan="3">
                                                                <ng-container *ngTemplateOutlet="attachmentsFieldsSection;"></ng-container>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                </tbody>
                                                <!-- <tbody *ngIf="activity_data.attachments.length == 0">
                                                    <tr>
                                                        <td colspan="3">
                                                            <div style="text-align: center">
                                                                <span>No Attachments Found</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody> -->
                                            </table>
                                        </ng-container>
                                        <ng-container *ngIf="attachment_operation_index == null">
                                            <ng-container *ngTemplateOutlet="attachmentsFieldsSection;"></ng-container>
                                        </ng-container>
                                        <div class="each-activity-details-button-section" *ngIf="attachment_operation_index != null && !isReadOnly">
                                            <button class="activity-more-action" (click)="openAttachmentOperation(attachment_data, 'Add', null)" style="margin-right: 0;">+ Add New Attachment</button>
                                        </div>
                                    </ng-container>

                                    <!-- Closed Deal Start -->
                                    <ng-container *ngIf="activity_tab_selected == 'Close Deal'">
                                        <ng-container>
                                            <ng-container *ngTemplateOutlet="productConversionSection;"></ng-container>
                                            <div class="each-activity-details-action-section">
                                                <button class="page-modal-primary-button" (click)="addProduct()">Save</button>
                                                <!-- <button class="page-modal-secondary-button" (click)="resetCloseDealData()">Cancel</button> -->
                                                <button class="page-modal-secondary-button" (click)="hideCloseDealView()">Cancel</button>
                                            </div>
                                        </ng-container>
                                    </ng-container>


                                    <ng-container *ngIf="activity_tab_selected == 'Change Outcome'">
                                        <ng-container>
                                            <ng-container *ngTemplateOutlet="outcomeConversionSection;"></ng-container>
                                            <div class="each-activity-details-action-section">
                                                <button class="page-modal-primary-button" (click)="addOutcome()">Save</button>
                                                <!-- <button class="page-modal-secondary-button" (click)="resetCloseDealData()">Cancel</button> -->
                                                <button class="page-modal-secondary-button" (click)="hideChangeOutcomeView()">Cancel</button>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                    <!-- <ng-container *ngIf="activity_tab_selected == 'History'"> -->
                                    <ng-container *ngIf="activity_tab_selected == 'Activity History'">
                                        <table class="activity-inner-table">
                                            <thead>
                                                <tr>
                                                    <th>Activity Name</th>
                                                    <th>Scheduled Date</th>
                                                    <th>Activity Status</th>
                                                    <th>Activity Type</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="activity_data.past_activities.length > 0">
                                                <tr *ngFor="let past_activity of activity_data.past_activities">
                                                    <td>
                                                        <p class="sub-activity-name">{{past_activity.name}}</p>
                                                    </td>
                                                    <td>
                                                        {{past_activity.scheduled_date | date: 'dd MMM yyyy'}}
                                                    </td>
                                                    <td>
                                                        <span class="activity-table-tag" [ngClass]="{'pending-status-tag': past_activity.status_name == 'Pending', 'completed-status-tag': past_activity.status_name == 'Completed', 'in-progress-status-tag': past_activity.status_name == 'In Progress', 'not-required-status-tag': past_activity.status_name == 'Not Required', 'cancelled-status-tag': past_activity.status_name == 'Cancelled'}">{{past_activity.status_name}}</span>
                                                    </td>
                                                    <td>
                                                        <span *ngIf="(past_activity.activity_type != 1) && (past_activity.activity_type != 4) && (past_activity.activity_type != 5)" class="activity-table-tag manual-task-tag">Manual</span>
                                                        <span *ngIf="(past_activity.activity_type == 1) || (past_activity.activity_type == 4) || (past_activity.activity_type == 5)"class="activity-table-tag automated-task-tag">Automated</span>
                                                        <ng-container *ngIf="past_activity.activity_type == 'Branch'">
                                                            <span class="activity-table-tag manual-task-tag">Branch</span>
                                                        </ng-container>
                                                        <ng-container *ngIf="past_activity.activity_type == 'Product'">
                                                            <span class="activity-table-tag automated-task-tag">Product</span>
                                                        </ng-container>
                                                        <ng-container *ngIf="past_activity.activity_type == 'Advisor Manager'">
                                                            <span class="activity-table-tag pending-status">Advisor Success Coach</span>
                                                        </ng-container>
                                                        <ng-container *ngIf="past_activity.activity_type == 'Advisor'">
                                                            <span class="activity-table-tag completed-status-tag">Advisor</span>
                                                        </ng-container>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody *ngIf="activity_data.past_activities.length == 0">
                                                <tr>
                                                    <td colspan="4">
                                                        <div style="text-align: center">
                                                            <span>No History Found</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </ng-container>

                                    <!-- <ng-container *ngIf="activity_tab_selected == 'Campaign History'"> -->
                                    <ng-container *ngIf="activity_tab_selected == 'Campaign Channel'">
                                        <table class="activity-inner-table">
                                            <thead>
                                                <tr>
                                                    <th>Campaign Date</th>
                                                    <th>Campaign Channel</th>
                                                    <th>Content</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="activity_data.campaign_history.length > 0">
                                                <tr *ngFor="let campaign of activity_data.campaign_history">
                                                    <td>
                                                        {{campaign.campaign_date | date: 'dd MMM yyyy'}}
                                                    </td>
                                                    <td>
                                                        <span class="activity-table-tag" [ngClass]="{'pending-status-tag': campaign.campaign_channel == 'Email Campaign', 'completed-status-tag': campaign.campaign_channel == 'Portal Campaign', 'in-progress-status-tag': campaign.campaign_channel == 'Message Campaign', 'not-required-status-tag': campaign.campaign_channel == 'Social Media Campaign'}">{{campaign.campaign_channel}}</span>
                                                    </td>
                                                    <td>
                                                        <p class="sub-activity-name" [innerHTML]="campaign.campaign_content"></p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody *ngIf="activity_data.campaign_history.length == 0">
                                                <tr>
                                                    <td colspan="3">
                                                        <div style="text-align: center">
                                                            <span>No Campaign History Found</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </ng-container>

                                    <ng-container *ngIf="activity_tab_selected == 'Capture Response'">
                                        <div id="capture-response-view">
                                            <ng-container *ngIf="activity_data.capture_response.captured_response == false">
                                                <div style="margin-top: 24px;">
                                                    <button class="capture-response-action" (click)="showCaptureResponse()">Capture Response</button>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="activity_data.capture_response.captured_response == true || show_capture_response_section">
                                                <div class="each-activity-details-section" >
                                                    <!-- <div class="each-activity-details-heading-section">
                                                        <div>
                                                            <span class="each-activity-details-heading">Response</span>
                                                            <img src="assets/activity-edit.png" class="activity-edit-icon" *ngIf="!isReadOnly && !show_capture_response_section" (click)="showCaptureResponse()" />
                                                        </div>
                                                    </div> -->
                                                    <ng-container *ngIf="!show_capture_response_section">
                                                        <div class="capture-response-details-section">
                                                            <div>
                                                                <span class="capture-response-date">{{activity_data.capture_response.response_capture_date | date: 'dd MMM yyyy'}}</span>
                                                            </div>
                                                            <div>
                                                                <div class="capture-response-channel-section">
                                                                    <img [src]="activity_data.capture_response.image_link" class="capture-response-channel-image" />
                                                                    <span>{{activity_data.capture_response.response_channel_name}}</span>
                                                                </div>
                                                                <div class="capture-response-channel-section">
                                                                    <span class="activity-table-tag completed-status-tag" *ngIf="activity_data.capture_response.response_status  ==  'Interested'">Interested</span>
                                                                    <span class="activity-table-tag cancelled-status-tag" *ngIf="activity_data.capture_response.response_status  ==  'Not Interested'">Not Interested</span>
                                                                    <!-- <span class="activity-table-tag pending-status-tag" *ngIf="activity_data.capture_response.response_status  ==  'No Contact'">No Contact</span> -->
                                                                    <span class="activity-table-tag pending-status-tag" *ngIf="activity_data.capture_response.response_status  ==  'No Response'">No Response</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="capture-response-comments-section">
                                                            <span [innerHTML]="activity_data.capture_response.response_comments"></span>
                                                        </div>
                                                        <div style="margin-top: 24px;">
                                                            <button class="capture-response-action" (click)="showCaptureResponse()">Edit Response</button>
                                                        </div>
                                                    </ng-container>

                                                    <ng-container *ngIf="show_capture_response_section">
                                                        <div class="capture-response-input-section">
                                                            <p class="capture-response-input-label">Response</p>


                                                          <!-- <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_status" (selectionChange)="showActivities($event.value)"> -->
                                                            <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_status">
                                                              <mat-option [value]="''">Select Response</mat-option>
                                                              <mat-option *ngFor="let response_option of response_options_list" [value]="response_option.name" (click)="showActivities(response_option)">{{ response_option.name }}</mat-option>
                                                          </mat-select>

                                                            <!-- <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_status">
                                                                <mat-option [value]="''">Select Response</mat-option>
                                                                <mat-option [value]="'Interested'">Interested</mat-option>
                                                                <mat-option [value]="'Not Interested'">Not Interested</mat-option>
                                                                <mat-option [value]="'No Response'">No Response</mat-option>
                                                            </mat-select> -->

                                                            <p class="input-error" *ngIf="capture_response_data_errors.response_status">Response is Required.</p>
                                                        </div>
                                                        <div class="capture-response-input-section">
                                                            <p class="capture-response-input-label">Response Channel</p>
                                                            <mat-select class="capture-response-input" [(ngModel)]="activity_data.capture_response.response_channel">
                                                                <mat-option [value]="''">Select Response Channel</mat-option>
                                                                <mat-option *ngFor="let communication_type of communication_type_list" [value]="communication_type.id">{{communication_type.name}}</mat-option>
                                                            </mat-select>
                                                            <p class="input-error" *ngIf="capture_response_data_errors.response_channel">Response Channel is Required.</p>
                                                        </div>
                                                        <div class="capture-response-input-section">
                                                            <p class="capture-response-input-label">Response Date</p>
                                                            <input
                                                                type="text"
                                                                class="capture-response-input"
                                                                bsDatepicker
                                                                placement="left"
                                                                [(ngModel)]="activity_data.capture_response.response_capture_date"
                                                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                                            />
                                                            <p class="input-error" *ngIf="capture_response_data_errors.response_capture_date">Response Date is Required.</p>
                                                        </div>
                                                        <div>
                                                            <div class="capture-response-input-section" style="width: 100%;">
                                                                <p class="capture-response-input-label">Notes</p>
                                                                <app-textarea-tagging [value]="activity_data.capture_response.response_comments" [users]="tagging_users_list" [placeholder]="'Notes ...'" (valueChanged)="activity_data.capture_response.response_comments = $event"></app-textarea-tagging>
                                                                <p class="input-error" *ngIf="capture_response_data_errors.response_comments">Notes is Required.</p>
                                                            </div>
                                                        </div>

                                                        <div class="selected-template-section" *ngIf="show_activities == true">
                                                          <div class="selected-template-heading-section">
                                                            <span>Please select the follow up activities</span>
                                                          </div>
                                                          <div class="selected-template-activities-section">
                                                            <p
                                                              class="each-coaching-plan-error"
                                                              *ngIf="select_activity_list_error"
                                                            >
                                                              Select minimum one Activity
                                                            </p>


                                                            <table class="activity-inner-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Name</th>
                                                                        <th>Description</th>
                                                                        <th>Channel</th>
                                                                        <th>Scheduled Date</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody *ngIf="activities_list.length > 0">
                                                                    <tr *ngFor="let activity of activities_list">
                                                                        <td>
                                                                            <mat-checkbox [checked]="activity.checked" (change)="activity.checked = !activity.checked" >{{ activity.name }}</mat-checkbox>
                                                                        </td>
                                                                        <td>
                                                                            {{ activity.description }}
                                                                        </td>
                                                                        <td>
                                                                            {{ activity.channel_name }}
                                                                        </td>
                                                                        <td style="position: relative;">
                                                                            <input
                                                                                type="text"
                                                                                class="select-template-input"
                                                                                #select_template_input="bsDatepicker"
                                                                                bsDatepicker
                                                                                placement="left"
                                                                                [(ngModel)]="activity.scheduled_date"
                                                                                [bsConfig]="{ dateInputFormat: 'YYYY/MM/DD' }"
                                                                                style="padding-right: 40px"
                                                                            />
                                                                            <img
                                                                                src="assets/calendar.png"
                                                                                class="select-template-input-icon"
                                                                                (click)="select_template_input.toggle()"
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                                <tbody *ngIf="activities_list.length == 0">
                                                                    <tr>
                                                                        <td colspan="3">
                                                                            <div style="text-align: center">
                                                                                <span>No Activities Found</span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>


                                                            <!-- <div
                                                              class="each-selected-template-activity-block"
                                                              *ngFor="let activity of activities_list"
                                                            >
                                                              <div class="each-selected-template-activity-section">
                                                                <mat-checkbox
                                                                  [checked]="activity.checked"
                                                                  (change)="activity.checked = !activity.checked"
                                                                  >{{ activity.name }}</mat-checkbox
                                                                >
                                                              </div>
                                                              <div class="each-selected-template-activity-section">
                                                                {{ activity.description }}
                                                              </div>
                                                              <div class="each-selected-template-activity-section">
                                                                {{ activity.channel_name }}
                                                              </div>
                                                              <div class="each-selected-template-activity-section">
                                                                <input
                                                                  type="text"
                                                                  class="select-template-input"
                                                                  #select_template_input="bsDatepicker"
                                                                  bsDatepicker
                                                                  placement="left"
                                                                  [(ngModel)]="activity.scheduled_date"
                                                                  [bsConfig]="{ dateInputFormat: 'YYYY/MM/DD' }"
                                                                  style="padding-right: 40px"
                                                                />
                                                                <img
                                                                  src="assets/calendar.png"
                                                                  class="select-template-input-icon"
                                                                  (click)="select_template_input.toggle()"
                                                                />
                                                              </div>
                                                            </div> -->
                                                          </div>
                                                        </div>


                                                        <div class="each-activity-details-action-section">
                                                            <button class="page-modal-primary-button" (click)="saveCaptureResponse()">Save</button>
                                                            <button class="page-modal-secondary-button" (click)="hideCaptureResponse()">Cancel</button>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>


                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!activity_data_loaded">
                <app-loader [loading_text]="'Loading Activity Data'"></app-loader>
            </ng-container>
        </div>
    </div>
</div>







<ng-template #activitiesDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Activity</span>
            <span class="client-modal-icon" (click)="closeDeleteActivityModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteActivity()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteActivityModal()">No</button>
        </div>
    </div>
</ng-template>



<ng-template #automatedActivitiesOperationModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Activity Operation</span>
            <span class="client-modal-icon" (click)="closeAutomatedActivityOperationModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">
                Do you want to
                <span *ngIf="activity_data.activity_paused">resume</span>
                <span *ngIf="!activity_data.activity_paused">stop</span> the activity
            </p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="automatedActivityOperation()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeAutomatedActivityOperationModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #activityEmailPreviewModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>{{ activity_email_data.template_name }}</span>
            <span class="page-modal-close-icon" (click)="closeActivityEmailPreviewModal()">&times;</span>
        </div>
        <div class="page-modal-content-section" *ngIf="activity_email_data_loaded">
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Subject: {{ activity_email_data.subject }}</p>
            </div>
            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Email Body:</p>
                <p class="page-modal-input-label" [innerHTML]="getHTML(activity_email_data.email_body)">{{ activity_email_data.template_name }}</p>
            </div>
            <div class="page-modal-input-section" *ngIf=" activity_email_data.greetings_image != '' && activity_email_data.greetings_image != null ">
                <button class="page-modal-primary-button" (click)="download(activity_email_data.greetings_image)" >Download Attachment</button>
            </div>
        </div>
        <div class="page-modal-content-section" *ngIf="!activity_email_data_loaded">
            <app-loader [loading_text]="'Loading'"></app-loader>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-secondary-button" (click)="closeActivityEmailPreviewModal()">Cancel</button>
        </div>
    </div>
</ng-template>

<ng-template #attachmentsFieldsSection>
    <div class="comments-fields-section">
        <div class="comment-details-section">
            <div class="attachment-details-input-section">
                <div class="attachment-upload-section">
                    <input type="file" #file_upload style="display: none;" (change)="uploadAttachment($event)" />
                    <button class="page-modal-primary-button" (click)="file_upload.click()">Upload Attachment</button>
                    <p class="attachment-name">{{attachment_data.attachment_filename}}</p>
                    <p class="input-error" *ngIf="attachment_data_errors.attachment_filename">Attachment is Required.</p>
                </div>
                <div class="attachment-input-section">
                    <app-textarea-tagging [value]="attachment_data.comments" [users]="tagging_users_list" [placeholder]="'Attachment Comments...'" (valueChanged)="attachment_data.comments = $event"></app-textarea-tagging>
                    <p class="input-error" *ngIf="attachment_data_errors.comments">Comments is Required.</p>
                </div>
            </div>
            <div class="activity-editable-action-section" *ngIf="!save_attachment_loader">
                <img src="assets/activity-save.png" class="activity-editable-action-icon" (click)="saveAttachment()" />
                <img src="assets/activity-cancel.png" class="activity-editable-action-icon" (click)="resetAttachmentData()" />
            </div>
            <div class="activity-editable-action-section" *ngIf="save_attachment_loader">
                <img src="assets/activity-save.png" class="activity-editable-action-icon" />
                <img src="assets/activity-cancel.png" class="activity-editable-action-icon" />
            </div>
        </div>
    </div>
</ng-template>

<ng-template #commentsFieldsSection>
    <div class="comments-fields-section">
        <div class="comment-details-section">
            <div class="comment-author-circle">
                <span>{{user_details.first_name[0]}}</span>
            </div>
            <div class="comment-details-input-section">
                <div class="comment-date-input-section">
                    <input
                        type="text"
                        class="capture-response-input"
                        bsDatepicker
                        placement="right"
                        [(ngModel)]="comment_data.comment_date"
                        [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                    />
                    <p class="input-error" *ngIf="comment_data_errors.comment_date">Date is Required.</p>
                </div>
                <div class="comment-input-section">
                    <app-textarea-tagging [value]="comment_data.description" [users]="tagging_users_list" [placeholder]="'Comment ...'" (valueChanged)="comment_data.description = $event"></app-textarea-tagging>
                    <p class="input-error" *ngIf="comment_data_errors.description">Comments is Required.</p>
                </div>
            </div>
            <div class="activity-editable-action-section" *ngIf="!save_comment_loader">
                <img src="assets/activity-save.png" class="activity-editable-action-icon" (click)="saveComment()" />
                <img src="assets/activity-cancel.png" class="activity-editable-action-icon" (click)="resetCommentsData()" />
            </div>
            <div class="activity-editable-action-section" *ngIf="save_comment_loader">
                <img src="assets/activity-save.png" class="activity-editable-action-icon" />
                <img src="assets/activity-cancel.png" class="activity-editable-action-icon" />
            </div>
        </div>
    </div>
</ng-template>


<!-- Comments Inputs Section -->
<ng-template #commentsSection>
    <div class="capture-response-section">
        <div class="capture-response-input-section" style="width: 50%;">
            <p class="capture-response-input-label">Date</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="comment_data.comment_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="comment_data_errors.comment_date">Date is Required.</p>
        </div>
        <div>
            <div class="capture-response-input-section" style="width: 100%;">
                <p class="capture-response-input-label">Comments</p>
                <app-textarea-tagging [value]="comment_data.description" [users]="tagging_users_list" [placeholder]="'Comment ...'" (valueChanged)="comment_data.description = $event"></app-textarea-tagging>
                <p class="input-error" *ngIf="comment_data_errors.description">Comments is Required.</p>
            </div>
        </div>
    </div>
</ng-template>

<!-- Attachments Inputs Section -->
<ng-template #attachmentsSection>
    <div class="capture-response-section">
        <div>
            <div class="capture-response-input-section" style="width: 50%;">
                <!-- <p class="capture-response-input-label">Upload Attachment</p> -->
                <input type="file" #file_upload style="display: none;" (change)="uploadAttachment($event)" />
                <button class="page-modal-primary-button" (click)="file_upload.click()">Upload Attachment</button>
                <span>{{attachment_data.attachment_filename}}</span>
                <p class="input-error" *ngIf="attachment_data_errors.attachment_filename">Attachment is Required.</p>
            </div>
        </div>
        <div>
            <div class="capture-response-input-section" style="width: 100%;">
                <p class="capture-response-input-label">Comments</p>
                <app-textarea-tagging [value]="attachment_data.comments" [users]="tagging_users_list" [placeholder]="'Attachment Comments ...'" (valueChanged)="attachment_data.comments = $event"></app-textarea-tagging>
                <p class="input-error" *ngIf="attachment_data_errors.comments">Comments is Required.</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #attachmentDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Attachment Details</span>
            <span class="client-modal-icon" (click)="closeDeleteAttachmentModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteAttachment()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteAttachmentModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #commentDeleteModal>
    <div class="modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Delete Comment Details</span>
            <span class="client-modal-icon" (click)="closeDeleteAttachmentModal()">&times;</span>
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteComment()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteCommentModal()">No</button>
        </div>
    </div>
</ng-template>










<!-- Conversion Status and Dropdown and its Products Starts -->
<ng-template #productConversionSection>
    <div class="capture-response-section">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Conversion Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="conversion_status_data.conversion_status" >
                <mat-option [value]="''">Select Conversion Status</mat-option>
                <mat-option *ngFor="let conversion_status of conversion_status_list" [value]="conversion_status.id" (click)=" conversion_status_data.conversion_status_name = conversion_status.name ">{{ conversion_status.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="conversion_status_data_errors.conversion_status">Conversion Status is Required.</p>
        </div>
        <div>
            <div class="capture-response-input-section" style="width: 100%;">
                <p class="capture-response-input-label">Comments *</p>
                <app-textarea-tagging [value]="conversion_status_data.conversion_comments" [users]="tagging_users_list" [placeholder]="'Comments ...'" (valueChanged)="conversion_status_data.conversion_comments = $event"></app-textarea-tagging>
                <p class="input-error" *ngIf="conversion_status_data_errors.conversion_comments">Comments is Required.</p>
            </div>
        </div>

        <ng-container *ngIf="user_details.role.business_area[0] == '5'">
            <ng-container *ngIf="conversion_status_data.conversion_status == 1">
                <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="user_details.role.business_area[0] == '6'">
            <ng-container *ngIf="conversion_status_data.conversion_status == 1">
                <ng-container *ngTemplateOutlet="depositproductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="user_details.role.business_area[0] == '7'">
            <ng-container *ngIf="conversion_status_data.conversion_status == 1">
                <ng-container *ngTemplateOutlet="lendingProductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="user_details.role.business_area[0] == '8'">
            <ng-container *ngIf="conversion_status_data.conversion_status == 1">
                <ng-container *ngTemplateOutlet="insuranceProductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

    </div>
</ng-template>
<!-- Conversion Status and Dropdown and its Products Ends -->



<ng-template #productOperationSection>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label" *ngIf="user_role != 'Relationship Manager'">Policy Number *</p>
            <p class="capture-response-input-label" *ngIf="user_role == 'Relationship Manager'">Deposit Number *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="product_data.policy_number" />
            <p class="input-error" *ngIf="product_data_errors.policy_number">
                <span *ngIf="user_role != 'Relationship Manager'">Policy Number</span>
                <span *ngIf="user_role == 'Relationship Manager'">Deposit Number</span>
                is Required.
            </p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">AUM *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="product_data.aum" (keypress)="numberOnly($event)" />
            <p class="input-error" *ngIf="product_data_errors.aum">AUM is Required.</p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.product">Product is Required.</p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Activated Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="product_data.start_date == '' || product_data.start_date == null" -->
            <p class="input-error" *ngIf="product_data_errors.start_date">Activated Date is Required.</p>
        </div>
        <div class="capture-response-input-section" *ngIf="getProductType(product_data.product)">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="product_data.close_date"
                [minDate]="product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="product_data_errors.close_date">Valid Until is Required.</p>
        </div>
        <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.deposit_purpose">Purpose is Required.</p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.type">Type is Required.</p>
        </div>
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>


<!-- deposit Product Operation Section Start -->
<ng-template #depositproductOperationSection>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;">

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(depositProduct_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.product">Product is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Policy Number *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.policy_number" />
            <p class="input-error" *ngIf="depositProduct_data_errors.policy_number">Policy Number is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Amount *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.aum" (input)="checkAmountValidation(depositProduct_data.product, depositProduct_data.aum)" (keypress)="numberOnly($event)" />
            <p class="input-error" *ngIf="depositProduct_data_errors.aum">Amount is Required.</p>
            <p class="input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Start Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="depositProduct_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="depositProduct_data_errors.start_date">Activated Date is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="depositProduct_data.close_date"
                [minDate]="depositProduct_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="depositProduct_data.start_date == '' || depositProduct_data.start_date == null" -->
            <p class="input-error" *ngIf="depositProduct_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.deposit_purpose">Purpose is Required.</p>
        </div> -->


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Tenure (Months) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.tenure" />
            <p class="input-error" *ngIf="depositProduct_data_errors.tenure">
                <span>Tenure</span>
                is Required.
            </p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Interest Rate (%) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.interest_rate" (keypress)="validateMaxValue($event, 100)" />
            <p class="input-error" *ngIf="depositProduct_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Monthly Fees *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="depositProduct_data.monthly_fees" />
            <p class="input-error" *ngIf="depositProduct_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.type">Type is Required.</p>
        </div>



        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="depositProduct_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="depositProduct_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>
<!-- deposit Product Operation Section End -->

<!-- Lending Product Operation Section Start -->
<ng-template #lendingProductOperationSection>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;">

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(lending_product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="lending_product_data_errors.product">Product is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Policy Number *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.policy_number" />
            <p class="input-error" *ngIf="lending_product_data_errors.policy_number">Policy Number is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Amount *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.aum" (input)="checkAmountValidation(lending_product_data.product, lending_product_data.aum)" (keypress)="numberOnly($event)" />
            <p class="input-error" *ngIf="lending_product_data_errors.aum">Amount is Required.</p>
            <p class="input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Start Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="lending_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="lending_product_data_errors.start_date">Activated Date is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="lending_product_data.close_date"
                [minDate]="lending_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="lending_product_data.start_date == '' || lending_product_data.start_date == null" -->
            <p class="input-error" *ngIf="lending_product_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="lending_product_data_errors.deposit_purpose">Purpose is Required.</p>
        </div> -->


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Tenure (Months) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.tenure" />
            <p class="input-error" *ngIf="lending_product_data_errors.tenure">
                <span>Tenure</span>
                is Required.
            </p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Interest Rate (%) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.interest_rate" (keypress)="validateMaxValue($event, 100)" />
            <p class="input-error" *ngIf="lending_product_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Monthly Fees *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="lending_product_data.monthly_fees" />
            <p class="input-error" *ngIf="lending_product_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="lending_product_data_errors.type">Type is Required.</p>
        </div>



        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="lending_product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="lending_product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>
<!-- Lending Product Operation Section End -->

 <!-- Insurance Product Operation Section Start -->
<ng-template #insuranceProductOperationSection>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;">

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Product *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(insurance_product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="insurance_product_data_errors.product">Product is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Policy Number *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.policy_number" />
            <p class="input-error" *ngIf="insurance_product_data_errors.policy_number">Policy Number is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Amount *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.aum" (input)="checkAmountValidation(insurance_product_data.product, insurance_product_data.aum)" (keypress)="numberOnly($event)" />
            <p class="input-error" *ngIf="insurance_product_data_errors.aum">Amount is Required.</p>
            <p class="input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Start Date *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="insurance_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="input-error" *ngIf="insurance_product_data_errors.start_date">Activated Date is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Valid Until *</p>
            <input
                type="text"
                class="capture-response-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="insurance_product_data.close_date"
                [minDate]="insurance_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <!-- [disabled]="insurance_product_data.start_date == '' || insurance_product_data.start_date == null" -->
            <p class="input-error" *ngIf="insurance_product_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <!-- <div class="capture-response-input-section" *ngIf="user_role == 'Relationship Manager'">
            <p class="capture-response-input-label">Purpose *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.deposit_purpose">
                <mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="insurance_product_data_errors.deposit_purpose">Purpose is Required.</p>
        </div> -->


        <!-- <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Tenure (Months) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.tenure" />
            <p class="input-error" *ngIf="insurance_product_data_errors.tenure">
                <span>Tenure</span>
                is Required.
            </p>
        </div> -->

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Interest Rate (%) *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.interest_rate" (keypress)="validateMaxValue($event, 100)" />
            <p class="input-error" *ngIf="insurance_product_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="capture-response-input-section">
            <p class="capture-response-input-label" >Monthly Fees *</p>
            <input type="text" class="capture-response-input" [(ngModel)]="insurance_product_data.monthly_fees" />
            <p class="input-error" *ngIf="insurance_product_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Type *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="insurance_product_data_errors.type">Type is Required.</p>
        </div>



        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Client Product Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="insurance_product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="insurance_product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>
<!-- Insurance Product Operation Section End -->



<ng-template #outcomeConversionSection>
    <div class="capture-response-section">
        <div class="capture-response-input-section">
            <p class="capture-response-input-label">Outcome Status *</p>
            <mat-select class="capture-response-input" [(ngModel)]="outcome_data.attrition_status" >
                <mat-option [value]="''">Select Outcome Status</mat-option>
                <mat-option [value]="'Retained'">Retained</mat-option>
                <mat-option [value]="'Retained, Upside'">Retained, Upside</mat-option>
                <mat-option [value]="'Likely to Switch Advisor'">Likely to Switch Advisor</mat-option>
            </mat-select>
            <p class="input-error" *ngIf="outcome_data_errors.attrition_status">Outcome Status is Required.</p>
        </div>
        <ng-container *ngIf="outcome_data.attrition_status == 'Likely to Switch Advisor'">
            <div class="capture-response-input-section">
                <p class="capture-response-input-label">Reason *</p>
                <mat-select class="capture-response-input" [(ngModel)]="outcome_data.attrition_comments" >
                    <mat-option [value]="''">Select Reason</mat-option>
                    <mat-option *ngFor="let attrition_reason of attrition_reasons_list" [value]="attrition_reason.name">{{attrition_reason.name}}</mat-option>
                </mat-select>
                <p class="input-error" *ngIf="outcome_data_errors.attrition_comments">Reason is Required.</p>
            </div>
        </ng-container>
        <div *ngIf="outcome_data.attrition_status != 'Likely to Switch Advisor'">
            <div class="capture-response-input-section" style="width: 100%;">
                <p class="capture-response-input-label">Comments *</p>
                <app-textarea-tagging [value]="outcome_data.attrition_comments" [users]="tagging_users_list" [placeholder]="'Comments ...'" (valueChanged)="outcome_data.attrition_comments = $event"></app-textarea-tagging>
                <p class="input-error" *ngIf="outcome_data_errors.attrition_comments">Comments is Required.</p>
            </div>
        </div>

        <ng-container *ngIf="user_details.role.business_area[0] == '5'">
            <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
                <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
            </ng-container>
        </ng-container>


        <ng-container *ngIf="user_details.role.business_area[0] == '6'">
            <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
                <ng-container *ngTemplateOutlet="depositproductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="user_details.role.business_area[0] == '7'">
            <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
                <ng-container *ngTemplateOutlet="lendingProductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="user_details.role.business_area[0] == '8'">
            <ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside'">
                <ng-container *ngTemplateOutlet="insuranceProductOperationSection;"></ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-template>


<ng-template #notificationModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span class="modal-heading">{{notification_data.campaign_channel}}</span>
            <span class="page-modal-close-icon" (click)="closeNotificationModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Notification Content *</p>
                    <app-textarea-tagging [value]="notification_data.campaign_content" [users]="[]" [placeholder]="'Notification Content ...'" (valueChanged)="notification_data.campaign_content = $event"></app-textarea-tagging>
                    <p class="input-error" *ngIf="notification_data_errors.campaign_content">Notification Content is Required.</p>
                </div>
            </div>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="sendNotification()">Send</button>
            <button class="page-modal-secondary-button" (click)="closeNotificationModal()">Cancel</button>
        </div>
    </div>
</ng-template>

<ng-template #scheduleMeetingModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span class="modal-heading">Schedule Meeting</span>
            <span class="page-modal-close-icon" (click)="closeScheduleMeetingModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Topic *</p>
                    <input type="text" class="capture-response-input" [(ngModel)]="meeting_data.topic" />
                    <p class="input-error" *ngIf="meeting_data_errors.topic">Topic is Required.</p>
                </div>
            </div>
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <!-- <p class="capture-response-input-label">Description</p> -->
                    <p class="capture-response-input-label">Meeting Notes *</p>
                    <!-- <app-textarea-tagging [value]="meeting_data.description" [users]="[]" [placeholder]="'Description ...'" (valueChanged)="meeting_data.description = $event"></app-textarea-tagging> -->
                    <app-textarea-tagging [value]="meeting_data.description" [users]="[]" [placeholder]="'Meeting Notes ...'" (valueChanged)="meeting_data.description = $event"></app-textarea-tagging>
                    <p class="input-error" *ngIf="meeting_data_errors.description">Description is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: calc(100% - 12px); margin-right: 12px;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <!-- <p class="capture-response-input-label">Attendees</p> -->
                    <p class="capture-response-input-label">Invite Others(Optional)</p>
                    <mat-chip-list #attendeesEmailList>
                        <mat-chip *ngFor="let email of meeting_data.attendees" [removable]="true" (removed)="removeAtteendeeEmail(email)">
                            {{email}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <div style="width: 100%;">
                            <input
                                class="capture-response-input"
                                placeholder="Attendee email..."
                                [matChipInputFor]="attendeesEmailList"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                [matChipInputAddOnBlur]="true"
                                (matChipInputTokenEnd)="addAtteendeeEmail($event)"
                            />
                        </div>
                    </mat-chip-list>
                    <div *ngIf="attendees_error" class="input-error">Invalid email address</div>
                    <p class="input-error" *ngIf="meeting_data_errors.attendees">Attendees is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: calc(50% - 12px); margin-right: 12px;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">When *</p>
                    <input
                        type="text"
                        class="capture-response-input"
                        bsDatepicker
                        placement="right"
                        [(ngModel)]="meeting_data.when"
                        [minDate]="current_date"
                        [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                        (ngModelChange)="generateTimeSlots()"
                    />
                    <p class="input-error" *ngIf="meeting_data_errors.when">When is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: calc(25% - 12px); margin-right: 12px;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Time *</p>
                    <mat-select class="capture-response-input" [(ngModel)]="meeting_data.time">
                        <mat-option [value]="''">Select Time</mat-option>
                        <mat-option *ngFor="let time_slot of time_slots" [value]="time_slot">{{time_slot}}</mat-option>
                    </mat-select>
                    <p class="input-error" *ngIf="meeting_data_errors.time">Time is Required.</p>
                </div>
            </div>
            <div style="display: inline-block; vertical-align: top; width: 25%;">
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Duration *</p>
                    <mat-select class="capture-response-input" [(ngModel)]="meeting_data.duration">
                        <mat-option [value]="''">Select Duration</mat-option>
                        <mat-option *ngFor="let duration_slot of duration_slots" [value]="duration_slot.value">{{duration_slot.name}}</mat-option>
                    </mat-select>
                    <p class="input-error" *ngIf="meeting_data_errors.duration">Duration is Required.</p>
                </div>
            </div>
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Timezone *</p>
                    <mat-select class="capture-response-input" [(ngModel)]="meeting_data.timezone">
                        <mat-option [value]="''">Select Timezone</mat-option>
                        <mat-option *ngFor="let timezone of timezone_list" [value]="timezone.value">{{timezone.name}}</mat-option>
                    </mat-select>
                    <p class="input-error" *ngIf="meeting_data_errors.timezone">Timezone is Required.</p>
                </div>
            </div>
            <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    <p class="capture-response-input-label">Platform *</p>
                    <mat-select class="capture-response-input" [(ngModel)]="meeting_data.platform">
                        <mat-option [value]="''">Select Platform</mat-option>
                        <mat-option [value]="'Zoom'">Zoom</mat-option>
                        <mat-option [value]="'Google Meet'">Google Meet</mat-option>
                        
                    </mat-select>
                    <p class="input-error" *ngIf="meeting_data_errors.platform">Platform is Required.</p>
                </div>
            </div>
            <!-- <div>
                <div class="capture-response-input-section" style="width: 100%; margin-right: 0;">
                    Commented <p class="capture-response-input-label">Attachments</p>
                    <p class="capture-response-input-label">Attachments(Optional)</p>
                    <input type="file" multiple style="display: none;" #meetingAtachmentFile (change)="uploadAtatchmentFile($event)" />
                    Commented <input type="file" style="display: none;" #meetingAtachmentFile (change)="uploadAtatchmentFile($event)" />
                    <button class="page-modal-primary-button" (click)="meetingAtachmentFile.click()">Upload</button>
                    <p class="input-error" *ngIf="meeting_data_errors.attachments">Attachments should be minimum one.</p>
                    <div class="each-proposal-document-section" *ngFor="let file of meeting_data.attachments; let index = index">
                        <span>{{file.name}}</span>
                        <span class="each-proposal-document-remove-icon" (click)="deleteAttachmentFile(index)">&times;</span>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="scheduleMeeting()">Send</button>
            <button class="page-modal-secondary-button" (click)="closeScheduleMeetingModal()">Cancel</button>
        </div>
    </div>
</ng-template>


<ng-template #statusChangeModal>
    <div class="page-modal-section">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Activity Status Update</span>
            <!-- <span class="client-modal-icon" (click)="closeStatusChangeModal()">&times;</span> -->
        </div>
        <div class="modal-content-section">
            <p class="page-modal-delete-description">Would you like to update the status of the pending subtasks to match the parent task's status, or change it to "Not Required"?</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="updateStatusChange('Yes')">Yes</button>
            <button class="page-modal-secondary-button" (click)="updateStatusChange('No')">No</button>
        </div>
    </div>
</ng-template>


<ng-template #followUpTasksModal>
    <div class="modal-section" style="width: 600px;">
        <div class="modal-heading-section client-view-heading-section">
            <!-- <span class="modal-heading">Follow Up Tasks</span> -->
            <span class="modal-heading">Warning: Unsaved Changes Detected</span>
            <!-- <span class="client-modal-icon" (click)="closeDeleteAttachmentModal()">&times;</span> -->
        </div>
        <div class="modal-content-section">
            <!-- <p class="page-modal-delete-description">By Closing some of the activity information is not being saved. Do you want to proceed?</p> -->
            <p class="page-modal-delete-description">You have made updates, but they haven't been saved yet. Do you want to proceed without saving? Click 'No' to go back and save your changes.</p>
        </div>
        <div class="modal-footer-section">
            <button class="page-modal-primary-button" (click)="closeFollowUpTasksModal()">Yes</button>
            <button class="page-modal-secondary-button" (click)="autoSaveFollowUp()">No</button>
        </div>
    </div>
</ng-template>


<ng-template #sendProposalModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">Send Document</span>
			<span class="page-modal-close-icon" (click)="closeSendProposalModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Objective *</p>
				<mat-select class="page-modal-input"  [(ngModel)]="proposal_data.objective_code">
					<mat-option [value]="''">Select Objective</mat-option>
					<mat-option *ngFor="let objective of objectives_list" [value]="objective.objective_code">{{objective.objective}}</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.objective_code">Objective is required.</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Product *</p>
				<mat-select class="page-modal-input"  [(ngModel)]="proposal_data.product">
					<mat-option [value]="''">Select Product</mat-option>
					<mat-option *ngFor="let product of products_list" [value]="product.id">{{product.name}}</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.product">Product is required.</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Scheduled Date *</p>
				<input
                  type="text"
                  class="page-modal-input"
                  bsDatepicker
                  [minDate]="current_date"
                  [(ngModel)]="proposal_data.scheduled_date"
                  [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                />
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.scheduled_date">Scheduled Date is required.</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Upload the Documents *</p>
				<input type="file" multiple style="display: none;" #proposalFile (change)="uploadProposalFile($event)" />
				<!-- <input type="file" style="display: none;" #proposalFile (change)="uploadProposalFile($event)" /> -->
				<button class="page-modal-primary-button" (click)="proposalFile.click()">Upload</button>
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.files">File should be minimum one.</p>
				<div class="each-proposal-document-section" *ngFor="let file of proposal_data.files; let index = index">
					<span>{{file.name}}</span>
					<span class="each-proposal-document-remove-icon" (click)="deleteProposalFile(index)">&times;</span>
				</div>
			</div>
			<!-- <div class="page-modal-input-section">
				<p class="page-modal-input-label">Description *</p>
				<app-textarea-tagging
					[value]="proposal_data.description"
					[users]="[]"
					[placeholder]="'Description ...'"
					(valueChanged)="proposal_data.description = $event"
				></app-textarea-tagging>
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.description">Description is required.</p>
			</div> -->
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Subject *</p>
				<input type="text" class="page-modal-input" [(ngModel)]="proposal_data.subject" />
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.subject">Subject is required.</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Email Body *</p>
				<angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="proposal_data.email_body" [config]="editorConfig"></angular-editor>
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.email_body">Body is required.</p>
			</div>
			<div class="page-modal-input-section">
				<mat-checkbox [(ngModel)]="move_record_stage_activity_status">Mark pending and in-progress activities as not required.</mat-checkbox>
			</div>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="sendProposal()">Save</button>
			<button class="page-modal-secondary-button" (click)="closeSendProposalModal()">Cancel</button>
		</div>
	</div>
</ng-template>

<ng-template #viewProposalModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">View Document</span>
			<span class="page-modal-close-icon" (click)="closeViewProposalModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Document Sent Date</p>
				<p class="page-modal-input">{{view_proposal_data.proposal_sent_date | date: 'dd MMM yyyy'}}</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Product</p>
				<p class="page-modal-input">{{view_proposal_data.product_name}}</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Objective</p>
				<p class="page-modal-input">{{view_proposal_data.objective}}</p>
			</div>
            <div class="page-modal-input-section">
				<p class="page-modal-input-label">Subject</p>
				<p class="page-modal-input">{{view_proposal_data.subject}}</p>
			</div>
            <div class="page-modal-input-section">
				<p class="page-modal-input-label">Email Body</p>
				<p class="page-modal-input" [innerHTML]="view_proposal_data.email_body" style="white-space: normal;"></p>
			</div>
			<!-- <div class="page-modal-input-section">
				<p class="page-modal-input-label">Status</p>
				<span class="activity-table-tag" [ngClass]="{'high-importance-tag': view_proposal_data.proposal_status == 1, 'medium-importance-tag': view_proposal_data.proposal_status == 2, 'low-importance-tag': view_proposal_data.proposal_status == 3}">{{view_proposal_data.proposal_status_name}}</span>
			</div> -->
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Documents</p>
				<div class="each-proposal-document-section" *ngFor="let file of view_proposal_data.documents; let index = index">
					<span>{{file.document_file_name}}</span>
					<!-- <span class="each-proposal-document-remove-icon" (click)="download(file.document)">&#x2193;</span> -->
					<img src="assets/attachment-download.png" class="each-proposal-document-remove-icon" (click)="download(file.document)" />

				</div>
			</div>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="closeViewProposalModal()">Close</button>
		</div>
	</div>
</ng-template>

<ng-template #closeDealModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">Capture Results</span>
			<span class="page-modal-close-icon" (click)="hideDealModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
            <ng-container>
                <ng-container *ngTemplateOutlet="productConversionSection;"></ng-container>
                <div class="each-activity-details-action-section">
                    <button class="page-modal-primary-button" (click)="addProduct()">Save</button>
                    <button class="page-modal-secondary-button" (click)="hideDealModal()">Cancel</button>
                </div>
            </ng-container>
		</div>
	</div>
</ng-template>

<ng-template #changeOutcomeModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">Capture Results</span>
			<span class="page-modal-close-icon" (click)="closeChangeOutcomeModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
            <ng-container>
                <ng-container *ngTemplateOutlet="outcomeConversionSection;"></ng-container>
            </ng-container>
		</div>
		<div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="addOutcome()">Save</button>
			<button class="page-modal-secondary-button" (click)="closeChangeOutcomeModal()">Cancel</button>
		</div>
	</div>
</ng-template>

<ng-template #captureresultsModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">Capture Results</span>
			<span class="page-modal-close-icon" (click)="hideCaptureresultsModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
            <ng-container>
                <div class="capture-response-section">
                    <div class="capture-response-input-section">
                        <p class="capture-response-input-label">Appointment Status *</p>
                        <mat-select class="capture-response-input" [(ngModel)]="capture_results_data.appointment_status_id" >
                            <mat-option [value]="''">Select Appointment Status</mat-option>
                            <mat-option *ngFor="let conversion_status of conversion_status_list" [value]="conversion_status.id" (click)=" capture_results_data.conversion_status_name = conversion_status.name ">{{ conversion_status.name }}</mat-option>
                        </mat-select>
                        <p class="input-error" *ngIf="capture_results_data_errors.appointment_status_id">Appointment Status is Required.</p>
                    </div>
                    <div>
                        <div class="capture-response-input-section" style="width: 100%;">
                            <p class="capture-response-input-label">Comments *</p>
                            <app-textarea-tagging [value]="capture_results_data.appointment_comments" [users]="tagging_users_list" [placeholder]="'Comments ...'" (valueChanged)="capture_results_data.appointment_comments = $event"></app-textarea-tagging>
                            <p class="input-error" *ngIf="capture_results_data_errors.appointment_comments">Comments is Required.</p>
                        </div>
                    </div>
                </div>
                <div class="each-activity-details-action-section">
                    <button class="page-modal-primary-button" (click)="saveCaptureResultsData()">Save</button>
                    <button class="page-modal-secondary-button" (click)="hideCaptureresultsModal()">Cancel</button>
                </div>
            </ng-container>
		</div>
	</div>
</ng-template>
